<template>
    <section class="valorant-binding-page" :aria-busy="busy">
        <div class="binding-announcement" role="note">战绩已大幅提升绑定成功率，欢迎体验！</div>
        <div class="binding-layout">
            <swiper
                ref="previewSwiper"
                class="binding-previews"
                :class="{ disabled: busy, ready: previewReady }"
                :options="swiperOptions"
                aria-label="战绩预览"
                @ready="onSwiperReady"
                @slideChange="onPreviewChange"
                @keydown.left.native.prevent="movePreview(-1)"
                @keydown.right.native.prevent="movePreview(1)"
            >
                <swiper-slide v-for="(preview, index) in previews" :key="`preview-${index}`" class="preview-slide">
                    <button
                        type="button"
                        class="preview-card"
                        :aria-label="preview.label"
                        :aria-current="activePreview === index ? 'true' : undefined"
                        :disabled="busy"
                        @click="selectPreview(index)"
                    >
                        <img class="preview-image" :src="preview.image" :alt="preview.label" draggable="false" />
                    </button>
                </swiper-slide>
                <div class="binding-preview-pagination" slot="pagination" aria-label="切换预览"></div>
            </swiper>
            <div class="binding-actions">
                <div class="binding-option">
                    <button type="button" class="login-button official-login" :disabled="busy" @click="login('official-login')">官方登录</button>
                    <p>速度快，成功率高</p>
                </div>
                <div class="binding-option">
                    <button type="button" class="login-button tracker-login" :disabled="busy" @click="login('tracker-login')">Tracker登录</button>
                    <p>速度较慢，可能需要官方验证</p>
                </div>
            </div>
            <p class="binding-support-note">当前仅支持国际服用户查询</p>
            <div v-if="busy" class="binding-loading" role="status" aria-label="正在登录"><i></i></div>
        </div>
        <van-popup
            class="tracker-sheet"
            position="bottom"
            role="dialog"
            aria-modal="true"
            aria-labelledby="tracker-binding-title"
            :value="trackerOpen"
            :close-on-click-overlay="!busy"
            @input="setTrackerOpen"
        >
            <form @submit.prevent="submitTracker">
                <h2 id="tracker-binding-title">Tracker登录</h2>
                <input
                    class="tracker-nickname"
                    type="text"
                    :value="account"
                    :disabled="busy"
                    aria-label="游戏昵称"
                    placeholder="输入游戏昵称,如player#01"
                    autocomplete="off"
                    @input="$emit('update:account', $event.target.value)"
                />
                <div class="tracker-sheet-actions">
                    <button type="button" class="tracker-cancel" :disabled="busy" @click="setTrackerOpen(false)">取消</button>
                    <button type="submit" class="tracker-confirm" :disabled="busy">确定</button>
                </div>
                <div class="tracker-safe-area" aria-hidden="true"></div>
            </form>
        </van-popup>
    </section>
</template>

<script>
/* global GSAppJsApi */
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import previewOverview from "./assets/preview-overview.png";
import previewCareer from "./assets/preview-career.png";
import previewTracker from "./assets/preview-tracker.png";

export default {
    name: "ValorantBindingPage",
    components: {
        Swiper: VueAwesomeSwiper.swiper,
        SwiperSlide: VueAwesomeSwiper.swiperSlide,
    },
    props: {
        busy: { type: Boolean, default: false },
        trackerOpen: { type: Boolean, default: false },
        account: { type: String, default: "" },
    },
    data() {
        return {
            activePreview: 1,
            previewReady: false,
            previews: [
                { image: previewOverview, label: "查看特工、武器子项数据" },
                { image: previewCareer, label: "一键查看生涯数据" },
                { image: previewTracker, label: "查看近期单局战绩详情" },
            ],
            swiperOptions: {
                initialSlide: 1,
                centeredSlides: true,
                slidesPerView: 3,
                spaceBetween: -35,
                slideToClickedSlide: true,
                loop: true,
                pagination: {
                    el: ".binding-preview-pagination",
                    clickable: true,
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
            },
        };
    },
    watch: {
        busy(value) {
            const swiper = this.getPreviewSwiper();
            if (!swiper) return;
            swiper.allowTouchMove = !value;
            if (swiper.autoplay) value ? swiper.autoplay.stop() : swiper.autoplay.start();
        },
    },
    methods: {
        getPreviewSwiper() {
            return this.$refs.previewSwiper && this.$refs.previewSwiper.swiper;
        },
        selectPreview(index) {
            if (this.busy) return;
            this.activePreview = index;
            const swiper = this.getPreviewSwiper();
            if (swiper && swiper.realIndex !== index) swiper.slideToLoop(index);
        },
        movePreview(direction) {
            if (this.busy) return;
            const swiper = this.getPreviewSwiper();
            if (swiper) direction > 0 ? swiper.slideNext() : swiper.slidePrev();
            else this.selectPreview((this.activePreview + direction + this.previews.length) % this.previews.length);
        },
        onSwiperReady(swiper) {
            this.activePreview = Number(swiper && swiper.realIndex) || 0;
            this.registerHorizontalScroll();
            this.$nextTick(() => {
                if (typeof window === "undefined" || typeof window.requestAnimationFrame !== "function") {
                    this.previewReady = true;
                    return;
                }
                window.requestAnimationFrame(() => {
                    window.requestAnimationFrame(() => { this.previewReady = true; });
                });
            });
        },
        onPreviewChange(swiper) {
            if (swiper && Number.isInteger(swiper.realIndex)) this.activePreview = swiper.realIndex;
        },
        registerHorizontalScroll() {
            this.$nextTick(() => {
                const element = this.$refs.previewSwiper && this.$refs.previewSwiper.$el;
                if (element && typeof GSAppJsApi !== "undefined" && GSAppJsApi.UI
                    && typeof GSAppJsApi.UI.registerHorizontalScrollWithHtmlNode === "function") {
                    GSAppJsApi.UI.registerHorizontalScrollWithHtmlNode(element);
                }
            });
        },
        login(event) {
            if (!this.busy) this.$emit(event);
        },
        setTrackerOpen(value) {
            if (!this.busy) this.$emit("update:trackerOpen", value);
        },
        submitTracker() {
            if (!this.busy) this.$emit("tracker-submit");
        },
    },
};
</script>

<style lang="scss" scoped>
.valorant-binding-page {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background: #0d151e;
    font-family: "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei", sans-serif;
    letter-spacing: 0;

    .binding-announcement {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        background-color: #ff4453;
        color: #fff;
        font-size: 12px;
        line-height: 26px;
        text-align: center;
    }

    .binding-layout {
        position: relative;
        width: 100%;
        max-width: 375px;
        min-height: 100vh;
        margin: 0 auto;
        padding: 37px 0 40px;
        box-sizing: border-box;
        background: url("./assets/background-top.png") no-repeat top / 100% auto;
    }

    .binding-previews {
        position: relative;
        left: -0.38465px;
        width: calc(100% - 30px);
        max-width: 344.2307px;
        aspect-ratio: 344.2307 / 398.0769;
        margin: 0 auto;
        overflow: visible;
        touch-action: pan-y;

        &.disabled { pointer-events: none; }

        ::v-deep .swiper-wrapper {
            align-items: flex-start;
            height: 380px;
        }
    }

    .preview-slide {
        z-index: 1;
        width: 138px;
        height: 263px;
        margin-top: 58.65px;
        transform-origin: center center;
        transition: none;

        &.swiper-slide-active {
            z-index: 2;
            transform: scale(1.4492754, 1.4448669);
        }
    }

    .binding-previews.ready .preview-slide {
        transition: transform 200ms ease;
    }

    .preview-slide.swiper-slide-duplicate-prev,
    .preview-slide.swiper-slide-duplicate-next,
    .preview-slide.swiper-slide-duplicate-active {
        opacity: 0;
        pointer-events: none;
    }

    .preview-card {
        display: block;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        border: 0;
        border-radius: 8px;
        background: none;
        overflow: hidden;
        cursor: pointer;
    }

    .preview-image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: fill;
        pointer-events: none;
    }

    .binding-preview-pagination {
        position: absolute;
        left: 50%;
        bottom: 0;
        z-index: 3;
        width: 28px;
        height: 4px;
        display: flex;
        justify-content: space-between;
        transform: translateX(-50%);

        ::v-deep .swiper-pagination-bullet {
            width: 4px;
            height: 4px;
            margin: 0;
            background: #6b7177;
            opacity: 1;
        }
        ::v-deep .swiper-pagination-bullet-active { background: #e9ecef; }
    }

    .binding-actions {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 10px;
        width: calc(100% - 32px);
        margin: 35.9231px auto 0;
    }

    .binding-option {
        min-width: 0;
        p {
            margin: 8px 0 0;
            color: #717173;
            font-size: 11px;
            font-weight: 400;
            line-height: normal;
            text-align: center;
        }
    }

    .login-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 41px;
        padding: 0 8px;
        box-sizing: border-box;
        border: 0;
        border-radius: 6px;
        color: #fff;
        font-family: inherit;
        font-size: 16px;
        font-weight: 500;
        line-height: 22.4px;
        letter-spacing: 0;
        cursor: pointer;

        &.official-login { background: #ff5062; }
        &.tracker-login { background: #2e2e33; }
        &:disabled { opacity: 0.6; cursor: default; }
    }

    .binding-support-note {
        margin: 22px 0 0;
        color: #717173;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: center;
    }

    button:focus-visible { outline: 2px solid #fff; outline-offset: 3px; }

    .tracker-sheet {
        left: 0;
        right: 0;
        width: 100%;
        max-width: none;
        margin: 0;
        background: #222226;
        border-radius: 12px 12px 0 0;
        color: #d7d7d9;
        font-family: inherit;

        form { margin: 0; padding-top: 16px; }
        h2 {
            margin: 0 16px 22px;
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
        }
        .tracker-nickname {
            display: block;
            width: calc(100% - 32px);
            height: 44px;
            margin: 0 16px;
            padding: 0 22px;
            box-sizing: border-box;
            border: 0;
            border-radius: 2px;
            background: #2e2e33;
            color: #d7d7d9;
            font: 500 12px/18px "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei", sans-serif;
            letter-spacing: 0;
            &::placeholder { color: #717173; opacity: 1; }
            &:focus-visible { outline: 1px solid #d7d7d9; outline-offset: 1px; }
        }
        .tracker-sheet-actions {
            display: grid;
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
            gap: 10px;
            margin-top: 16px;
            padding: 5px 16px 4px;
            button {
                height: 40px;
                padding: 8px;
                border: 0;
                border-radius: 4px;
                background: none;
                color: #999;
                font: 400 16px/24px "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei", sans-serif;
                letter-spacing: 0;
                cursor: pointer;
                &:disabled { opacity: 0.6; cursor: default; }
            }
            .tracker-confirm { background: #fffffd; color: #212121; }
        }
        .tracker-safe-area {
            height: 34px;
            height: max(34px, env(safe-area-inset-bottom, 0px));
        }
    }

    .binding-loading {
        position: absolute;
        inset: 0;
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(13, 21, 30, 0.45);
        i {
            width: 30px;
            height: 30px;
            background: url("../../assets/image/loading.png") no-repeat center / 100%;
            animation: binding-rotate 1s linear infinite;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .preview-slide { transition: none; }
    }
}

@keyframes binding-rotate {
    to { transform: rotate(360deg); }
}
</style>
